import { CSSProperties } from 'react';
import { IProduct, TDiscountStyle } from 'mod/product/interface';
import { getStoreState } from 'base/store'
import { IActivityCode, IStyleConfig, ITagSite } from 'base/interfacesV2/feature'
import { ISpuInfo, IVariant } from 'base/interfaces/product';

export const getDiscountText = (discount: IProduct['discount'], discountStyle?: TDiscountStyle): string => {
    if (!discount) {
        return '';
    }
    const { text, type } = discount;

    if (!!discountStyle) {
        if (discountStyle === 'OFF') {
            return `${text} OFF`
        }
        return `-${text}`;
    } else {

        if (type === 'percent') {
            return `${text} OFF`
        }
        return `-${text}`;
    }
}

// 获取当前活动tag配置、当前活动tag 位置配置
export const getTagConfig = (
    activityCode?: IActivityCode,
    tagSite?: ITagSite
): IStyleConfig | undefined => {
    if (!activityCode || !tagSite) {
        return
    }

    const serverStore = getStoreState('persistStore')
    const { tagTheme } = serverStore
    const { current: curtTagTheme } = tagTheme || {}
    const siteConfig = curtTagTheme?.[activityCode]?.[tagSite] || {}

    return {
        ...siteConfig,
        tagType: activityCode
    }
}

// 获取tag元素样式
export const getTagElStyles = (
    tagConfig?: IStyleConfig
) => {

    if (tagConfig) {
        const {
            cornerRadius,
            borderColor,
            titleBackgroundColor,
            titleColor,
            descBackgroundColor,
            descColor,
        } = tagConfig
        // div
        const titleStyle: CSSProperties = {
            ...(titleColor
                ? { color: titleColor || '', }
                : {}),
            ...(titleBackgroundColor
                ? { backgroundColor: titleBackgroundColor || '' }
                : {}),
        };

        const descStyle: CSSProperties = {
            ...(descColor
                ? { color: descColor || '', }
                : {}),
            ...(descBackgroundColor
                ? { backgroundColor: descBackgroundColor || '' }
                : {}),
        }

        const wrapStyle: CSSProperties = {
            ...(cornerRadius
                ? { borderRadius: cornerRadius || '0px' }
                : {}),
            ...((borderColor)
                ? { border: `1px solid ${borderColor}` }
                : {}),
        }

        return {
            titleStyle,
            descStyle,
            wrapStyle
        }
    }
}

// 获取未下架且有库存的variant id
export const getOnSaleIds = (variants: IVariant[]): string[] => {
    const ids: string[] = [];
    for (let variant of variants) {
        if (variant.isOnSale && variant.stockNum > 0) {
            ids.push(variant.productVariantId)
        }
    }
    return ids;
}

// 获取默认variant
export function getDefaultVariant(spu: ISpuInfo): IVariant {
    const { selectedVariantId, productVariants: variants } = spu;
    const onSaleIds = getOnSaleIds(variants);
    const ids = variants.map(item => item.productVariantId);
    let defaultId: string = ids[0];
    if (selectedVariantId && ids.includes(selectedVariantId)) {
        // url中带variantId参数的，默认选择对应sku
        defaultId = selectedVariantId;
    } else if (onSaleIds.length > 0) {
        // 选第一个有库存的，都没有库存时默认选第一个
        defaultId = onSaleIds[0];
    }
    return variants.find(item => item.productVariantId === defaultId) as IVariant;
}